module.exports = function anonymous(locals, escapeFn, include, rethrow) {
    rethrow = rethrow || function rethrow(err, str, flnm, lineno, esc) {
        var lines = str.split("\n");
        var start = Math.max(lineno - 3, 0);
        var end = Math.min(lines.length, lineno + 3);
        var filename = esc(flnm);
        var context = lines.slice(start, end).map(function(line, i) {
            var curr = i + start + 1;
            return (curr == lineno ? " >> " : "    ") + curr + "| " + line;
        }).join("\n");
        err.path = filename;
        err.message = (filename || "ejs") + ":" + lineno + "\n" + context + "\n\n" + err.message;
        throw err;
    };
    escapeFn = escapeFn || function(markup) {
        return markup == undefined ? "" : String(markup).replace(_MATCH_HTML, encode_char);
    };
    var _ENCODE_HTML_RULES = {
        "&": "&amp;",
        "<": "&lt;",
        ">": "&gt;",
        '"': "&#34;",
        "'": "&#39;"
    }, _MATCH_HTML = /[&<>'"]/g;
    function encode_char(c) {
        return _ENCODE_HTML_RULES[c] || c;
    }
    var __line = 1, __lines = '<%\n\nvar msg = require(\'@cdo/locale\');\n\n/**\n * Add the procedures category to the toolbox.\n */\nvar addProcedures = function() { -%>\n  <category name="<%= msg.catProcedures() %>" custom="PROCEDURE"></category>\n  <category name="<%= msg.catLogic() %>">\n    <block type="karel_if"></block>\n    <block type="karel_ifElse"></block>\n  </category>\n<% }; -%>\n\n<%\n/**\n * Options:\n * @param doStatement An optional statement for the do statement in the loop.\n * @param upperLimit The upper limit of the for loop.\n */\nvar controlsFor = function(doStatement, upperLimit) { -%>\n  <block type="controls_for">\n    <value name="FROM">\n      <block type="math_number">\n        <title name="NUM">1</title>\n      </block>\n    </value>\n    <value name="TO">\n      <block type="math_number">\n        <title name="NUM">\n          <%= upperLimit || 10 -%>\n        </title>\n      </block>\n    </value>\n    <value name="BY">\n      <block type="math_number">\n        <title name="NUM">1</title>\n      </block>\n    </value>\n    <% if (doStatement) { -%>\n      <statement name="DO">\n        <% doStatement() %>\n      </statement>\n    <% } -%>\n  </block>\n<% }; -%>\n\n<xml id="toolbox" style="display: none;">\n  <category name="<%= msg.catActions() %>">\n    <block type="maze_moveForward"></block>\n    <block type="maze_turn"><title name="DIR">turnLeft</title></block>\n    <block type="maze_turn"><title name="DIR">turnRight</title></block>\n    <block type="maze_dig"></block>\n    <block type="maze_fill"></block>\n  </category>\n  <% addProcedures() -%>\n  <category name="<%= msg.catLoops() %>">\n    <block type="maze_untilBlockedOrNotClear"></block>\n    <% if (level < 9) { -%>\n      <block type="controls_repeat"></block>\n    <% } else { -%>\n      <block type="controls_repeat_ext">\n        <value name="TIMES">\n          <block type="math_number">\n            <title name="NUM">10</title>\n          </block>\n        </value>\n      </block>\n    <% } -%>\n    <% controlsFor() -%>\n  </category>\n  <category name="<%= msg.catMath() %>">\n    <block type="math_number"></block>\n  </category>\n  <category name="<%= msg.catVariables() %>" custom="VARIABLE">\n  </category>\n</xml>\n', __filename = "src/maze/toolboxes/karel3.xml.ejs";
    try {
        var __output = [], __append = __output.push.bind(__output);
        with (locals || {}) {
            var msg = require("@cdo/locale");
            var addProcedures = function() {
                __line = 8;
                __append('  <category name="');
                __line = 9;
                __append(escapeFn(msg.catProcedures()));
                __append('" custom="PROCEDURE"></category>\n  <category name="');
                __line = 10;
                __append(escapeFn(msg.catLogic()));
                __append('">\n    <block type="karel_if"></block>\n    <block type="karel_ifElse"></block>\n  </category>\n');
                __line = 14;
            };
            __append("\n");
            __line = 16;
            var controlsFor = function(doStatement, upperLimit) {
                __line = 22;
                __append('  <block type="controls_for">\n    <value name="FROM">\n      <block type="math_number">\n        <title name="NUM">1</title>\n      </block>\n    </value>\n    <value name="TO">\n      <block type="math_number">\n        <title name="NUM">\n          ');
                __line = 32;
                __append(escapeFn(upperLimit || 10));
                __append('        </title>\n      </block>\n    </value>\n    <value name="BY">\n      <block type="math_number">\n        <title name="NUM">1</title>\n      </block>\n    </value>\n    ');
                __line = 41;
                if (doStatement) {
                    __append('      <statement name="DO">\n        ');
                    __line = 43;
                    doStatement();
                    __append("\n      </statement>\n    ");
                    __line = 45;
                }
                __append("  </block>\n");
                __line = 47;
            };
            __append('\n<xml id="toolbox" style="display: none;">\n  <category name="');
            __line = 50;
            __append(escapeFn(msg.catActions()));
            __append('">\n    <block type="maze_moveForward"></block>\n    <block type="maze_turn"><title name="DIR">turnLeft</title></block>\n    <block type="maze_turn"><title name="DIR">turnRight</title></block>\n    <block type="maze_dig"></block>\n    <block type="maze_fill"></block>\n  </category>\n  ');
            __line = 57;
            addProcedures();
            __append('  <category name="');
            __line = 58;
            __append(escapeFn(msg.catLoops()));
            __append('">\n    <block type="maze_untilBlockedOrNotClear"></block>\n    ');
            __line = 60;
            if (level < 9) {
                __append('      <block type="controls_repeat"></block>\n    ');
                __line = 62;
            } else {
                __append('      <block type="controls_repeat_ext">\n        <value name="TIMES">\n          <block type="math_number">\n            <title name="NUM">10</title>\n          </block>\n        </value>\n      </block>\n    ');
                __line = 70;
            }
            __append("    ");
            __line = 71;
            controlsFor();
            __append('  </category>\n  <category name="');
            __line = 73;
            __append(escapeFn(msg.catMath()));
            __append('">\n    <block type="math_number"></block>\n  </category>\n  <category name="');
            __line = 76;
            __append(escapeFn(msg.catVariables()));
            __append('" custom="VARIABLE">\n  </category>\n</xml>\n');
            __line = 79;
        }
        return __output.join("");
    } catch (e) {
        rethrow(e, __lines, __filename, __line, escapeFn);
    }
}